/** @module Specification/SizeMap/NewSizeMap */
define([
	"dojo/_base/declare",
	"csi/table/New",
	"csi/xml"
], function(declare,New,xml) {

	var TARGET_SIZE_RANGE = "TargetSizeRange";

	return declare(New, {

		/**
		 * @override
		 * Add TargetSizeRange to the the call params
		 */
		toWriter: function() {
			this.inherited(arguments).addParameter(TARGET_SIZE_RANGE, xml.ATTR_REF, this.m_formData.getFieldValue(TARGET_SIZE_RANGE));
		}

	});
});